import { WHATSAPP_URL } from "@/lib/constants";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { trackConversion } from "@/lib/tracking";

/**
 * Persistent floating WhatsApp button — bottom-right, always visible on both
 * desktop and mobile. Uses the WhatsApp brand green (#25D366).
 */
export const FloatingWhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      onClick={trackConversion(WHATSAPP_URL)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Discuter avec DEM BAT sur WhatsApp"
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white shadow-[0_8px_24px_rgba(37,211,102,0.45)] hover:shadow-[0_12px_32px_rgba(37,211,102,0.55)] flex items-center justify-center transition-all duration-300 hover:scale-105 active:scale-95 group"
    >
      <WhatsAppIcon className="w-7 h-7 sm:w-8 sm:h-8" />
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 pointer-events-none" />
      {/* Desktop tooltip */}
      <span className="hidden md:block absolute right-full mr-3 px-3 py-1.5 bg-charcoal-deep text-white text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        Discuter sur WhatsApp
      </span>
    </a>
  );
};
